import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

function loadView(view) {
  return () => import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`);
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    if (to.hash) {
      return {
        selector: to.hash,
      };
    }

    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/rolunk',
      name: 'About',
      component: loadView('About'),
    },
    {
      path: '/szolgaltatasok/:slug?',
      name: 'Services',
      component: loadView('Services'),
    },
    {
      path: '/szolgaltatasok/:serviceSlug/:subServiceSlug',
      name: 'SubServices',
      component: loadView('SubServices'),
    },
    {
      path: '/anyagleadas',
      name: 'MaterialDelivery',
      component: loadView('MaterialDelivery'),
    },
    {
      path: '/kapcsolat',
      name: 'Contact',
      component: loadView('Contact'),
    },
    {
      path: '/adatvedelmi-nyilatkozat',
      name: 'PrivacyStatement',
      component: loadView('PrivacyStatement'),
    },
    {
      path: '/jogi-nyilatkozat',
      name: 'LegalNotice',
      component: loadView('LegalNotice'),
    },
    {
      path: '/adatkezelesi-tajekoztato',
      name: 'PrivacyPolicy',
      component: loadView('PrivacyPolicy'),
    },
    {
      path: '/szechenyi-terv-plusz',
      name: 'SzechenyiPlanPlus',
      component: loadView('SzechenyiPlanPlus'),
    },
    {
      path: '/szechenyi-2020-palyazat',
      name: 'SzechenyiPlan',
      component: loadView('SzechenyiPlan'),
    },
    {
      path: '/',
      name: 'Home',
      component: loadView('Home'),
    },
    {
      path: '*',
      name: '404',
      redirect: { name: 'Home' },
    },
  ],
});
